import { render, staticRenderFns } from "./footer-logo.vue?vue&type=template&id=0a90da68"
import script from "./footer-logo.ts?vue&type=script&lang=ts&external"
export * from "./footer-logo.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports